/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback, useMemo } from 'react';
import * as actions from '../redux/actions';
import * as actionsV from 'features/viewing/redux/actions';
import T from 'i18n';
import { useDispatch, useSelector } from 'react-redux';
import { usePrevious } from 'utils/hooks';
import history from 'common/history';
import { withoutTrailingSlash } from 'utils/path';
import { Modal } from 'features/common/MaterialBasedComponents';
import {
  selectBundleTabPage,
  selectCurrentFolder,
  selectDocuments,
  selectPermissions,
  selectMinIdWidth,
  selectCaseDataRoomSettings,
  selectShowExhibitNumber,
  selectUserDataRoomSettings,
  selectParams,
  selectCurrentFolderAgreed,
  selectDeepSearch,
  selectWiderColumns,
  selectWiderDateColumn,
  selectCurrentCaseId,
  selectClickEnterToPresent,
  selectDocSearchVal,
  selectIsDeepSearchPerformed,
  selectAISearch,
  selectPreserveAttchedFileSortOrder,
  selectFetchDocumentsPending,
  selectDisableSearchFromAllDocs,
  selectCurrentSelectedFileMetaData,
  selectCurrentFileMetData,
} from 'common/selectors';
import Table, { filterByGlobalPage, getStringValue } from '../../common/Table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import CircularProgress from '@mui/material/CircularProgress';
import { createSelector } from 'reselect';
import { getSortFunction, sortDocumentsWithAttachments } from 'features/common/Table/utils';
import columnsSelector from './columnsSelector';
import useSearchContext from 'features/common/Search/useSearchContext';
import equal from 'react-fast-compare';

const filterByColumns = [
  'id',
  'disclosureId',
  'familyId',
  'author',
  'type',
  'classifyType',
  'classifySubtype',
  'name',
  'originalName',
  'folderSpecificName',
  'discoveryId',
  'externalId',
  'description',
  'notes',
  'recipient',
  'recipientsList',
  // {
  //   id: 'createdBy',
  //   accessor: ({ createdBy }: any) =>
  //     createdBy &&
  //     `${moment(createdBy.date)
  //       .utc()
  //       .format('DD/MM/YYYY HH:mm')} ${createdBy.name}`,
  // },
  // {
  //   id: 'addedBy',
  //   accessor: ({ addedBy }: any) =>
  //     addedBy &&
  //     `${moment(addedBy.date)
  //       .utc()
  //       .format('DD/MM/YYYY HH:mm')} ${addedBy.name}`,
  // },
  // {
  //   id: 'lastEditedBy',
  //   accessor: ({ lastEditedBy }: any) =>
  //     lastEditedBy &&
  //     `${moment(lastEditedBy.date)
  //       .utc()
  //       .format('DD/MM/YYYY HH:mm')} ${lastEditedBy.name}`,
  // },
  // {
  //   id: 'assignedTo',
  //   accessor: ({ assignedTo }: any) =>
  //     assignedTo && assignedTo.map((item: any) => T.translate(`case.${item}`)).join(', '),
  // },
  // {
  //   id: 'locations',
  //   accessor: ({ locations }: any) => locations && locations.join(', '),
  // },
  {
    id: 'bundleLocations',
    accessor: ({ bundleLocations }: any) =>
      bundleLocations && bundleLocations.map((item: any) => item.fileName),
  },
];

const DEFAULT_COLUMNS = ['index', 'name', 'info'];
const DEFAULT_SMALL_COLUMNS = ['index', 'name', 'info'];

const normalizeWithDefaults = (columns: string[] | null | undefined, defaults: string[]) =>
  Array.from(new Set([...(Array.isArray(columns) ? columns : []), ...defaults]));

const onDoubleClickHandlerSelector = createSelector(
  (present?: 'private' | 'public') => present,
  (_: any, useCompositeKey: any) => useCompositeKey,
  (_: any, __: any, docSearchVal: any) => docSearchVal,
  (_: any, __: any, ___: any, setDocSearchVal: any) => setDocSearchVal,
  (_: any, __: any, ___: any, ____: any, dispatch: any) => dispatch,
  (present, useCompositeKey, docSearchVal, setDocSearchVal, dispatch: any) => (row: any) => {
    history.push(
      history.location.pathname.replace(/\/files.*/, ``) +
        `/files/${row.id}${useCompositeKey ? `/compositeKey/${row.compositeKey}` : ``}${
          present ? `?present=${present}` : ''
        }`,
    );
    if (docSearchVal) setDocSearchVal('');
    dispatch(actions.setCurrentSelectedFile(row));
  },
);
const updateSortHandlerSelector = createSelector(
  (dispatch: any) => dispatch,
  (_: any, currentFolder: any) => currentFolder,
  (dispatch, currentFolder) =>
    (index: any, ids: any, singleDroppedDocId: string, hasFolderFieldId: boolean) => {
      dispatch(
        actions.updateDocumentSort({
          index,
          ids,
          zeroBasedIndex: currentFolder.zeroBasedIndex,
          agreed: currentFolder.agreed,
          singleDroppedDocId,
          hasFolderFieldId,
        } as any),
      );
    },
);

const updateDocumentSortSelector = createSelector(
  (
    dispatch: any,
    documents: any,
    currentFolder: any,
    setShowModal: any,
    preserveAttchedFileSortOrder: any,
  ) => ({
    dispatch,
    documents,
    currentFolder,
    setShowModal,
    preserveAttchedFileSortOrder,
  }),
  ({ dispatch, documents, currentFolder, setShowModal, preserveAttchedFileSortOrder }: any) =>
    (sortByColumn: any, sortDirection: any, onCustomSort: any) => {
      const fn = () => {
        dispatch(actions.modifyDocumentSortSelection({ sortByColumn, sortDirection } as any));
        const sortFunc = getSortFunction(sortByColumn, sortDirection, onCustomSort);
        const sortedData =
          preserveAttchedFileSortOrder && sortFunc
            ? sortDocumentsWithAttachments(documents, sortFunc)
            : documents.slice().sort(sortFunc);
        const ids = sortedData.map(
          ({ folderFileId, compositeKey, id }: any) => folderFileId || compositeKey || id,
        );
        if (!equal(sortedData, documents))
          dispatch(
            actions.updateDocumentSort({
              ids,
              zeroBasedIndex: currentFolder.zeroBasedIndex,
              agreed: currentFolder.agreed,
              sortDirection,
              sortByColumn,
              singleDroppedDocId: false,
              hasFolderFieldId: sortedData[0]?.folderFileId ? true : false,
            } as any),
          );
      };
      if (setShowModal) setShowModal({ fn });
      else fn();
    },
);

const additionalDragInfoSelector = createSelector(selectCurrentFolder, ({ code }) => ({
  folderCode: code,
}));

const findPageByFilterTerm = (doc: any, filterVal: any) => {
  // Check for complex bundle tab page format with dots (like "G4.0/2/6" or "A99.99/5/6")
  if (/^[A-Za-z][A-Za-z0-9]*(\.\d{1,2})?\/\d+\/\d+$/.test(filterVal)) {
    const parts = filterVal.split('/');
    if (parts.length === 3) {
      // Return the page number directly from the third part
      const pageNumber = parseInt(parts[2], 10);
      return pageNumber;
    }
  }

  // Check for ticket format pattern (e.g., "TV-426-9885/5")
  if (/^[A-Za-z]+-\d{2,3}-\d{4,}\/\d{1,4}$/.test(filterVal)) {
    const parts = filterVal.split('/');
    if (parts.length === 2) {
      // Return the page number directly from the second part
      return parseInt(parts[1], 10);
    }
  }

  // Check for shorter ticket format pattern (e.g., "TV-426/9" or "TV-42/9")
  if (/^[A-Za-z]+-\d{2,}\/\d{1,4}$/.test(filterVal)) {
    const parts = filterVal.split('/');
    if (parts.length === 2) {
      // Return the page number directly from the second part
      return parseInt(parts[1], 10);
    }
  }

  // Check for numeric ticket formats (e.g., "426-3761/9" or "6-3761/9")
  if (/^\d+-\d+\/\d{1,4}$/.test(filterVal)) {
    const parts = filterVal.split('/');
    if (parts.length === 2) {
      // Return the page number directly from the second part
      return parseInt(parts[1], 10);
    }
  }

  // Check for numeric ID/page pattern (e.g., "3761/9")
  if (/^[0-9]{1,6}[/][0-9]{1,7}?$/.test(filterVal)) {
    const parts = filterVal.split('/');
    if (parts.length === 2) {
      // Return the page number directly from the second part
      return parseInt(parts[1], 10);
    }
  }

  // Check for bundle tab page format (e.g., "E/1/8", "B1/2/10", etc.)
  if (/^[A-Za-z][A-Za-z0-9]?\/[\d.]+\/[\d.]+$/.test(filterVal)) {
    const parts = filterVal.split('/');
    if (parts.length === 3) {
      // Return the page number directly from the third part
      return parseInt(parts[2], 10);
    }
  }

  // Original fallback logic
  const startPage = doc.startPage && doc.startPage.split('.');
  const lpSearch = filterVal && /^[0-9]{1,6}[/][0-9]{1,7}?$/.test(filterVal);
  const gpSearch =
    !doc.matches && filterVal && /^[a-zA-Z][A-Za-z0-9]*(\.\d{1,2})?$/.test(filterVal);
  const searchItem = gpSearch && filterVal && filterVal.length > 0 && filterVal;
  const searchIdx =
    (searchItem &&
      doc &&
      doc.globalPagePrefix &&
      searchItem.toLowerCase().replace(doc.globalPagePrefix.toLowerCase(), '')) ||
    (lpSearch && filterVal && filterVal.split('/')[1]) ||
    '';
  const goToPage =
    (gpSearch &&
      searchIdx.includes('.') &&
      startPage.length > 1 &&
      parseInt(searchIdx.split('.')[1], 10) - parseInt(startPage[1], 10) + 1) ||
    (gpSearch && parseInt(searchIdx, 10) - parseInt(doc.startPage, 10) + 1) ||
    (lpSearch && parseInt(searchIdx, 10)) ||
    1;
  return goToPage;
};

export const filterAndPresent = (
  allDocs: any,
  filterVal: any,
  setFile: any,
  canPresentToHearingRoom: boolean,
) => {
  const filteredData = allDocs.filter((row: any) => {
    // For complex formats with dots in prefix like "G4.0/3/6" or "A99.99/5/6"
    if (/^[A-Za-z][A-Za-z0-9]*(\.\d{1,2})?\/\d+\/\d+$/.test(filterVal)) {
      const parts = filterVal.split('/');
      const prefix = parts[0]; // e.g., "G4.0" or "A99.99"
      const tab = parts[1]; // e.g., "3" or "5"

      // Check if document has matching prefix and tab
      if (
        row.globalPagePrefix &&
        row.globalPagePrefix.toLowerCase() === prefix.toLowerCase() &&
        getStringValue(row, 'tab').toLowerCase() === tab.toLowerCase()
      ) {
        const pageNo = parseInt(parts[2], 10);
        // Make sure the page number is valid for this document
        return !isNaN(pageNo) && pageNo >= 1 && pageNo <= parseInt(row.pageCount, 10);
      }
      return false;
    }

    if (/^[A-Za-z]+-\d{2,3}-\d{4,}\/\d{1,4}$/.test(filterVal)) {
      const parts = filterVal.split('/');
      const ticketId = parts[0]; // e.g., "TV-426-9885"

      return ['id', 'name', 'originalName', 'externalId', 'discoveryId'].some(
        (field) => row[field] && String(row[field]).toLowerCase().includes(ticketId.toLowerCase()),
      );
    }

    // For shorter ticket format like "TV-426/9" or "TV-42/5"
    if (/^[A-Za-z]+-\d{2,}\/\d{1,4}$/.test(filterVal)) {
      const parts = filterVal.split('/');
      const ticketId = parts[0]; // e.g., "TV-426"

      return ['id', 'name', 'originalName', 'externalId', 'discoveryId'].some(
        (field) => row[field] && String(row[field]).toLowerCase().includes(ticketId.toLowerCase()),
      );
    }

    // For numeric ticket formats like "426-3761/9" or "6-3761/9"
    if (/^\d+-\d+\/\d{1,4}$/.test(filterVal)) {
      const parts = filterVal.split('/');
      const ticketId = parts[0]; // e.g., "426-3761"

      return ['id', 'name', 'originalName', 'externalId', 'discoveryId'].some((field) => {
        if (!row[field]) return false;
        const fieldValue = String(row[field]).toLowerCase();
        const ticketIdLower = ticketId.toLowerCase();
        const matches = fieldValue.includes(ticketIdLower);
        return matches;
      });
    }

    // For simple numeric ID/page pattern like "3761/9"
    if (/^[0-9]{1,6}[/][0-9]{1,7}?$/.test(filterVal)) {
      const parts = filterVal.split('/');
      const docId = parts[0]; // e.g., "3761"

      return ['id', 'name', 'originalName', 'externalId', 'discoveryId'].some(
        (field) => row[field] && String(row[field]).toLowerCase().includes(docId.toLowerCase()),
      );
    }

    // For global page references like "E123", "AB45.6", "A9.99", "A99.99"
    if (/^[a-zA-Z][A-Za-z0-9]*(\.\d{1,2})?$/.test(filterVal)) {
      return filterByGlobalPage(row, filterVal);
    }
    // For patterns like "A/11", "A/2/123", "A/1.1/1", "B/2.3.1/2.2"
    else if (/^[A-Za-z][A-Za-z0-9]?\/[\d.]+(?:\/[\d.]+)?$/.test(filterVal)) {
      const parts = filterVal.split('/');
      const prefix = parts[0]; // Can be 'A', 'B1', 'AB', etc.
      const tab = parts[1]; // Tab number like '1', '11', '1.1'
      const pageNumber = parts.length > 2 ? parts[2] : null; // Optional page number

      // Check if document has matching prefix and tab
      if (
        row.globalPagePrefix &&
        row.globalPagePrefix.toLowerCase() === prefix.toLowerCase() &&
        getStringValue(row, 'tab').toLowerCase() === tab.toLowerCase()
      ) {
        // If there's a page number specified (like in "E/1/2")
        if (pageNumber !== null) {
          const pageNo = parseInt(pageNumber, 10);
          // Make sure the page number is valid for this document
          return !isNaN(pageNo) && pageNo >= 1 && pageNo <= parseInt(row.pageCount, 10);
        }
        // If it's just prefix/tab (like "E/1"), it's a match
        return true;
      }
      return false;
    } else {
      return getStringValue(row, filterByColumns[0])
        .toLowerCase()
        .includes(filterVal.toLowerCase());
    }
  });

  if (filteredData.length > 0) {
    const goToPage = findPageByFilterTerm(filteredData[0], filterVal);
    history.push(
      history.location.pathname.replace(/\/files.*/, ``) +
        `/files/${filteredData[0].id}/compositeKey/${filteredData[0].compositeKey}${
          canPresentToHearingRoom
            ? `?goToPage=${goToPage || 1}&present=public`
            : `?goToPage=${goToPage || 1}`
        } 
        }`,
    );

    setFile(filteredData[0]);
  }
};
const TableCase = React.memo(
  React.forwardRef(
    (
      {
        onRowSelected,
        isAllDocuments,
        isRecycleBin,
        isQuickLinksPage,
        isPresentModePage,
        isPresentModeWithBackEnd,
        onFilterChanged,
        onFilterCategoryChanged,
        isSearchModePage,
        isAiToolsPage,
        isDocFinderPage,
        gridList,
        setGridList,
        setSortMode,
        sortMode,
        editMode,
        setEditMode,
        isTrialBooks,
        isTagsPage,
        filter,
        setFilter,
        actualFilter,
        filterOperators,
        filterOrder,
        mappedRowsWithErrors,
        onQuickUpload,
        suppressRows,
        uploadEmptyState,
        handleShow,
        getFolderSpecificFileDetails,
        onOpenViewDrawer,
      }: {
        onRowSelected: any;
        isAllDocuments: any;
        isRecycleBin: any;
        isQuickLinksPage: any;
        isPresentModePage: any;
        isPresentModeWithBackEnd: any;
        onFilterChanged: any;
        onFilterCategoryChanged: any;
        isSearchModePage: any;
        isAiToolsPage: any;
        isDocFinderPage: any;
        gridList?: any;
        setGridList: any;
        setSortMode: React.Dispatch<React.SetStateAction<boolean>>;
        sortMode: boolean;
        editMode: boolean;
        setEditMode: React.Dispatch<React.SetStateAction<boolean>>;
        isTrialBooks: any;
        isTagsPage: any;
        filter: any;
        setFilter: any;
        actualFilter: any;
        filterOperators?: Record<string, 'and' | 'or'>;
        filterOrder?: string[];
        mappedRowsWithErrors: any;
        onQuickUpload?: () => void;
        suppressRows?: boolean;
        uploadEmptyState?: React.ReactNode;
        handleShow?: any;
        getFolderSpecificFileDetails?: any;
        onOpenViewDrawer?: any;
      },
      ref,
    ) => {
      const { searchHandler, searchFunctionsHandler, clearSearch } = useSearchContext();
      const [isFetchDocInitiated, setIsFetchDocInitiated] = useState(false);
      const [showModal, setShowModal] = useState<any>(undefined);
      const [key, setKey] = useState(Math.random());
      const fetchDocumentsPending = useSelector(selectFetchDocumentsPending);
      const currentFolder = useSelector(selectCurrentFolder);
      const isBundleTabPage = useSelector(selectBundleTabPage);
      const prevCurrentFolder = usePrevious(currentFolder) as any;
      const prevIsAllDocuments = usePrevious(isAllDocuments);
      const prevIsRecycleBin = usePrevious(isRecycleBin);
      const documents = useSelector(selectDocuments) as Array<any>;
      const totalDocumentsCount = documents.length;
      const permissions = useSelector(selectPermissions);
      const userDataRoomSettings = useSelector(selectUserDataRoomSettings);
      const caseDataRoomSettings = useSelector(selectCaseDataRoomSettings);
      const showExhibitNumber = useSelector(selectShowExhibitNumber);
      const filterByColumnsWithExhibit = useMemo(
        () => (showExhibitNumber ? [...filterByColumns, 'exhibitNumber'] : filterByColumns),
        [showExhibitNumber],
      );
      const { file, compositeKey }: any = useSelector(selectParams);
      const lastSelectedFile = useSelector((state: any) => state.case.lastSelectedFile) as any;
      const lastSelectedCategory = useSelector((state: any) => state.case.lastSelectedCategory);
      const lastSelectedBundle = useSelector((state: any) => state.case.lastSelectedBundle);
      const fileData = useSelector(selectCurrentFileMetData) as any;
      const present = useSelector(({ matcher: { query = {} } }: any) => query.present);
      const additionalDragInfo = useSelector(additionalDragInfoSelector);
      const minIdWidth = useSelector(selectMinIdWidth);
      const isTrialBookAgreed = useSelector(selectCurrentFolderAgreed);
      const isReadOnlyTrialbook = currentFolder.readOnly;
      const isDisableSearchFromAllDocs = useSelector(selectDisableSearchFromAllDocs);
      const isAllDocumentsLike = isAllDocuments || isRecycleBin;
      const showDeepSearch =
        useSelector(selectDeepSearch) &&
        ((isAllDocumentsLike && !isDisableSearchFromAllDocs) ||
          isSearchModePage ||
          isDocFinderPage ||
          isPresentModeWithBackEnd);
      const showGoToPageFilter = currentFolder && currentFolder.globalPaging;
      const isWiderColumns = useSelector(selectWiderColumns);
      const isWiderDateColumn = useSelector(selectWiderDateColumn);
      const currentCaseId = useSelector(selectCurrentCaseId);
      const isClickEnterToPresent = useSelector(selectClickEnterToPresent);
      const dispatch = useDispatch();
      const currentUrlHashVal = window.location.hash;
      const hashFileId = currentUrlHashVal.split('#')[1];
      const isTagsFolder = currentFolder && currentFolder.type === 'quicklinks';
      const docSearchVal = useSelector(selectDocSearchVal);
      const isDeepSearchPerformed = useSelector(selectIsDeepSearchPerformed);
      const isAISearch = useSelector(selectAISearch) && isAiToolsPage;
      const preserveAttchedFileSortOrder = useSelector(selectPreserveAttchedFileSortOrder);
      const currentSelectedFileMetaData = useSelector(selectCurrentSelectedFileMetaData);
      const isIndexFolder =
        currentFolder &&
        currentFolder.name === 'index' &&
        currentFolder.type === 'trialbook' &&
        currentFolder.readOnly;
      const canPresentToHearingRoom =
        permissions && permissions.hearingRoom && permissions.hearingRoom.canPresent('public');

      const resolvedColumns = useMemo(() => {
        const selectedByCase =
          currentCaseId && userDataRoomSettings?.selectedColumns?.[currentCaseId];
        const caseDefaults =
          caseDataRoomSettings?.columns && caseDataRoomSettings.columns.length
            ? caseDataRoomSettings.columns
            : DEFAULT_COLUMNS;
        return normalizeWithDefaults(selectedByCase || caseDefaults, DEFAULT_COLUMNS);
      }, [currentCaseId, userDataRoomSettings?.selectedColumns, caseDataRoomSettings?.columns]);

      const resolvedSmallColumns = useMemo(() => {
        const selectedByCase =
          currentCaseId && userDataRoomSettings?.selectedColumnsSmallView?.[currentCaseId];
        const caseDefaults =
          caseDataRoomSettings?.columnsSmallView && caseDataRoomSettings.columnsSmallView.length
            ? caseDataRoomSettings.columnsSmallView
            : DEFAULT_SMALL_COLUMNS;
        return normalizeWithDefaults(selectedByCase || caseDefaults, DEFAULT_SMALL_COLUMNS);
      }, [
        currentCaseId,
        userDataRoomSettings?.selectedColumnsSmallView,
        caseDataRoomSettings?.columnsSmallView,
      ]);
      const filterByTerm = (term: any) => {
        setFilter((prev: any) => ({
          ...prev,
          term: term ? term : '',
        }));
        onRowSelected && onRowSelected([]);
      };

      const filterByOptions = (category: any) => {
        setFilter((prev: any) => ({ ...prev, ...category }));
        onRowSelected && onRowSelected([]);
        onFilterCategoryChanged && onFilterCategoryChanged(category);
      };

      const setFile = (f: any) => dispatch(actions.setCurrentSelectedFile(f));

      const setDocSearchVal = (val: any, keyPhrase?: string, fileId?: string) => {
        if (isSearchModePage && docSearchVal !== val) {
          if (keyPhrase && fileId) {
            dispatch(actions.parseMatch({ fileId, text: val, keyPhrase })).then((res: string) => {
              dispatch(actionsV.setDocSearch(res));
            });
          } else dispatch(actionsV.setDocSearch(val));
        } else if (!isSearchModePage && docSearchVal) dispatch(actionsV.setDocSearch(''));
      };

      const presentFirstDoc = (allDocs: any, val: any) => {
        if (!fetchDocumentsPending && allDocs.length > 0) {
          const goToPage = findPageByFilterTerm(allDocs[0], val);
          history.push(
            history.location.pathname.replace(/\/files.*/, ``) +
              `/files/${allDocs[0].id}${canPresentToHearingRoom ? `?goToPage=${goToPage || 1}&present=public` : `?goToPage=${goToPage || 1}`}`,
          );
          setFile(allDocs[0]);
        }
      };

      const clearSearchedFiles = (allDocs: any) => {
        if (allDocs.length > 0) {
          dispatch(actions.clearDocuments());
        }
      };

      const onMount = () => {
        searchFunctionsHandler &&
          searchFunctionsHandler({
            searchChanged: filterByTerm,
            filterChanged: filterByOptions,
            deepSearchChanged: (val: any) => {
              isAISearch
                ? dispatch(actions.fetchMatches({ searchTerm: val }))
                : dispatch(
                    actions.fetchSearchedFiles({
                      searchTerm: val,
                      isDocFinderPage: isDocFinderPage || isPresentModeWithBackEnd,
                      isSearchModePage,
                      isPresentModeWithBackEnd,
                    }),
                  );
            },
            presentToHearingRoom: (allDocs: any, val: any) => {
              return val && filterAndPresent(allDocs, val, setFile, canPresentToHearingRoom);
            },
            presentFirstDoc,
            clearSearchedFiles,
          });
      };

      const shouldClearDocuments = (
        uriCurrentFolder: string | undefined,
        cf: any,
        pathname: string,
      ) => {
        const allDocsPath = `${currentCaseId}/all-documents`;
        const recycleBinPath = `${currentCaseId}/recycle-bin`;
        const presentModePath = `${currentCaseId}/present-view`;
        const searchModePath = `${currentCaseId}/search-mode`;
        const docFinderPath = `${currentCaseId}/docFinder`;
        const isAllDocsPath = pathname.includes(allDocsPath);
        const isRecycleBinPath = pathname.includes(recycleBinPath);

        return (
          (cf && cf.code && uriCurrentFolder !== cf.code) ||
          (Object.keys(cf).length === 0 &&
            !isAllDocsPath &&
            !isRecycleBinPath &&
            !pathname.includes(searchModePath) &&
            !pathname.includes(presentModePath) &&
            !pathname.includes(docFinderPath) &&
            (isAllDocumentsLike ||
              isPresentModePage ||
              isSearchModePage ||
              isDocFinderPage ||
              isPresentModeWithBackEnd)) ||
          (isAllDocsPath && !isAllDocumentsLike) ||
          (isRecycleBinPath && !isRecycleBin) ||
          (pathname.includes(presentModePath) &&
            (isPresentModeWithBackEnd ? !isPresentModeWithBackEnd : !isPresentModePage)) ||
          (pathname.includes(searchModePath) && !isSearchModePage) ||
          (pathname.includes(docFinderPath) && !isDocFinderPage)
        );
      };

      const clearDocumentState = useCallback(() => {
        setSortMode(false);
        setShowModal(undefined);
        setKey(Math.random());
        setIsFetchDocInitiated(false);
        clearSearch && clearSearch();
        dispatch(actions.clearDocuments());
        dispatch(actions.setFilterOptions(null));
        dispatch(actions.setCurrentSelectedFile(null));
      }, [clearSearch, dispatch]);

      const currentFolderId = currentFolder?.id;
      const prevCurrentFolderId = prevCurrentFolder?.id;

      const shouldFetchDocuments = useCallback(() => {
        if (isFetchDocInitiated || fetchDocumentsPending) return false;
        const hasFolder = Boolean(currentFolderId);
        const folderChanged = hasFolder && currentFolderId !== prevCurrentFolderId;
        const hasNoDocs = totalDocumentsCount === 0;
        return (
          isAllDocumentsLike ||
          isPresentModePage ||
          folderChanged ||
          (hasFolder && hasNoDocs)
        );
      }, [
        isFetchDocInitiated,
        fetchDocumentsPending,
        currentFolderId,
        prevCurrentFolderId,
        totalDocumentsCount,
        isAllDocumentsLike,
        isPresentModePage,
      ]);

      const fetchDocuments = () => {
        dispatch(
          actions.fetchDocuments({
            ...(isPresentModePage && { presentMode: true }),
            ...(isRecycleBin && { recycleBin: true }),
          }),
        );
        setIsFetchDocInitiated(true);
      };

      // MOUNT

      useEffect(onMount, []);

      useEffect(() => {
        if (sortMode && clearSearch) {
          clearSearch();
        }
      }, [sortMode]);
      useEffect(() => {
        if (
          (typeof prevIsAllDocuments !== 'undefined' && prevIsAllDocuments !== isAllDocuments) ||
          (typeof prevIsRecycleBin !== 'undefined' && prevIsRecycleBin !== isRecycleBin)
        ) {
          clearDocumentState();
        }
      }, [prevIsAllDocuments, prevIsRecycleBin, isAllDocuments, isRecycleBin, clearDocumentState]);
      useEffect(() => {
        return (
          searchHandler &&
          searchHandler({
            isReady: !sortMode,
            placeholder: showDeepSearch ? T.translate('case.search') : T.translate('case.quickFilter'),
            showDeepSearch,
            isPresentModePage,
            isSearchModePage,
            isDocFinderPage,
            isPresentModeWithBackEnd,
            isClickEnterToPresent,
            useOnlyIdColForPresentMode: false,
            isAllDocsWithLongList: isAllDocumentsLike && totalDocumentsCount > 8000,
            showGoToPageFilter,
            selectedColumns: file ? resolvedSmallColumns : resolvedColumns,
            documents,
          })
        );
      }, [
        sortMode,
        searchHandler,
        showDeepSearch,
        showGoToPageFilter,
        isPresentModePage,
        isPresentModeWithBackEnd,
        isClickEnterToPresent,
        resolvedColumns,
        resolvedSmallColumns,
        documents,
        isSearchModePage,
        isDocFinderPage,
        file,
        totalDocumentsCount,
      ]);

      useEffect(() => {
        const unlisten = history.listen((e) => {
          const withoutFilesPart = (url: string) => url.replace(/\/files\/.*$/, '');
          const uriCurrentFolder = withoutFilesPart(withoutTrailingSlash(e.pathname))
            .split('/')
            .pop();

          if (shouldClearDocuments(uriCurrentFolder, currentFolder, e.pathname)) {
            clearDocumentState();
          }
        });

        if (shouldFetchDocuments()) {
          fetchDocuments();
        }

        return () => {
          if (unlisten) {
            unlisten();
          }
        };
      }, [currentFolder, shouldFetchDocuments, history, clearDocumentState]);

      // set file data when page is loaded from url and fileData is not set
      // TO-DO - remove this while using folderFileId in url
      useEffect(() => {
        if (file && fileData && Object.keys(currentSelectedFileMetaData).length === 0) {
          setFile(fileData);
        }
      }, [file, fileData, currentSelectedFileMetaData]);

      useEffect(() => {
        if (currentFolder.type === 'quicklinks') return;
        // hashFileId is used for auto scrolling and selecting file -> when you select file location from full size viewer
        // Also select by `file` param whenever it changes, regardless of metadata being loaded
        if (hashFileId || file || lastSelectedFile) {
          documents.forEach((doc: any) => {
            const shouldSelectDocument =
              isPresentModePage || isIndexFolder
                ? doc.compositeKey === compositeKey
                : hashFileId
                  ? doc.id === hashFileId || doc.folderFileId === hashFileId
                  : file
                    ? doc.id === file
                    : lastSelectedFile
                      ? doc.id === lastSelectedFile.id
                      : false;
            if (shouldSelectDocument) {
              doc.selected = true;
            } else if (
              ((isPresentModePage || isIndexFolder) && present) ||
              isSearchModePage ||
              isAllDocumentsLike
            ) {
              doc.selected = false;
            }
          });

          onRowSelected && onRowSelected(documents.filter(({ selected }: any) => !!selected));
        }
      }, [
        hashFileId,
        documents,
        onRowSelected,
        currentFolder.type,
        file,
        lastSelectedFile,
        compositeKey,
        isPresentModePage,
        isIndexFolder,
        present,
        isSearchModePage,
        isAllDocumentsLike,
      ]);

      // Clear lastSelected when category or bundle changes (segments after caseId)
      useEffect(() => {
        const pathParts = history.location.pathname.split('/');
        // ['', 'case', caseId, category, bundle, ...]
        const categorySegment = pathParts[3] || null;
        const bundleSegment = pathParts[4] || null;
        if (
          (lastSelectedCategory && lastSelectedCategory !== categorySegment) ||
          (lastSelectedBundle && lastSelectedBundle !== bundleSegment)
        ) {
          dispatch({ type: 'CASE_CLEAR_LAST_SELECTED_FILE' } as any);
        }
      }, [history.location.pathname, lastSelectedCategory, lastSelectedBundle, dispatch]);

      const updateDocumentSort = updateDocumentSortSelector(
        dispatch,
        documents,
        currentFolder,
        typeof showModal === 'undefined' && setShowModal,
        preserveAttchedFileSortOrder,
      );

      const updateSortHandler = updateSortHandlerSelector(dispatch, currentFolder);
      const onDoubleClickHandler = onDoubleClickHandlerSelector(
        present,
        isPresentModePage || isIndexFolder,
        docSearchVal,
        setDocSearchVal,
        dispatch,
      );
      const selectedColumns = resolvedColumns;
      const configureColumns = (columns: any) =>
        columns && [
          ...columns,
          ...(isQuickLinksPage && isTagsFolder
            ? ['viewed', 'dateViewed']
            : showGoToPageFilter || isPresentModePage
              ? ['globalPages']
              : []),
        ];

      const selectedColumnsSmallView = resolvedSmallColumns;
      const tableRef = React.useRef<any>(null);
      const showDocFinderTab =
        (isDocFinderPage || isPresentModeWithBackEnd) &&
        isBundleTabPage &&
        documents.find(
          (doc: any) =>
            (doc.globalPagePrefix && doc.tab) ||
            (doc.bundleLocations &&
              doc.bundleLocations[0] &&
              doc.bundleLocations[0].globalPagePrefix &&
              doc.bundleLocations[0].tab),
        );

      const columns = columnsSelector(
        file,
        configureColumns(selectedColumns),
        configureColumns(selectedColumnsSmallView),
        permissions,
        sortMode,
        setSortMode,
        editMode,
        setEditMode,
        updateDocumentSort,
        minIdWidth,
        isTrialBookAgreed,
        isReadOnlyTrialbook,
        isQuickLinksPage,
        showGoToPageFilter,
        present,
        filter,
        currentFolder,
        isWiderDateColumn,
        isWiderColumns,
        isPresentModePage,
        isPresentModeWithBackEnd,
        isTagsFolder,
        setDocSearchVal,
        tableRef,
        setFile,
        canPresentToHearingRoom,
        isSearchModePage,
        isBundleTabPage,
        showDocFinderTab,
        handleShow,
        getFolderSpecificFileDetails,
        onRowSelected,
        onOpenViewDrawer,
        showExhibitNumber,
      );
      const onAddFilesClick = () => {
        if (onQuickUpload) onQuickUpload();
      };
      const isBundleFolder =
        currentFolder &&
        ['bundle', 'team-bundle', 'private-bundle', 'trialbook'].includes(
          (currentFolder as any).type,
        );

      const shouldShowEmptyState =
        isBundleFolder &&
        !isSearchModePage &&
        !isDocFinderPage &&
        !isPresentModeWithBackEnd &&
        !isAllDocumentsLike;

      const canUploadDocsFn = (permissions as any)?.folders?.canUploadDocuments;
      const canUploadDocs = canUploadDocsFn ? canUploadDocsFn(currentFolder) : true;

      const addFilesEmptyState = (
        <div style={{ textAlign: 'center', justifyContent: 'center', padding: '2rem' }}>
          {!canUploadDocs && (
            <div style={{ color: '#9a9a9a', marginBottom: '0.5rem', fontSize: 14 }}>
              {T.translate('case.noUploadPermission')}
            </div>
          )}
          <div style={{ marginTop: '2rem' }}>
            <p
              style={{
                fontSize: '2.25rem',
                marginBottom: '0.5rem',
                color: canUploadDocs ? '#666' : '#9a9a9a',
              }}
            >
              {T.translate('case.addFilesToBundle')}
            </p>
          </div>
          <button
            onClick={onAddFilesClick}
            style={{
              background: 'transparent',
              border: 'none',
              flexDirection: 'column',
              alignItems: 'center',
              cursor: canUploadDocs ? 'pointer' : 'not-allowed',
              opacity: canUploadDocs ? 1 : 0.5,
            }}
            disabled={!canUploadDocs}
          >
            <div
              style={{
                width: 44,
                height: 44,
                borderRadius: '50%',
                backgroundColor: '#c5c5c5ff',
                alignItems: 'center',
                display: 'flex',
                justifyContent: 'center',
                margin: '2rem auto',
                cursor: canUploadDocs ? 'pointer' : 'not-allowed',
              }}
            >
              <FontAwesomeIcon icon={faPlus} color="#ffffffff" size="lg" />
            </div>
            <p
              style={{
                fontSize: '1.25rem',
                marginBottom: '0.5rem',
                color: canUploadDocs ? '#666' : '#9a9a9a',
              }}
            >
              {T.translate('case.clickOrDragToUpload')}
            </p>
          </button>
        </div>
      );
      const loaderEmptyState = (
        <div style={{ padding: '48px 0', textAlign: 'center', color: '#666' }}>
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: 10 }}>
            <CircularProgress size={20} />
            <span>{T.translate('case.loadingDocuments')}</span>
          </div>
        </div>
      );
      const combinedEmptyState =
        suppressRows && uploadEmptyState
          ? uploadEmptyState
          : fetchDocumentsPending
            ? loaderEmptyState
            : shouldShowEmptyState && totalDocumentsCount === 0
              ? addFilesEmptyState
              : undefined;
      return (
        <>
          <Table
            key={key}
            ref={tableRef}
            filter={actualFilter}
            onRowSelected={onRowSelected}
            data={suppressRows || fetchDocumentsPending ? [] : documents}
            columns={columns}
            filterByColumns={
              isPresentModePage
                ? ['id', 'name', 'discoveryId', 'externalId']
                : filterByColumnsWithExhibit
            }
            sortMode={sortMode}
            editMode={editMode}
            updateSort={updateSortHandler}
            onDoubleClick={onDoubleClickHandler}
            additionalDragInfo={additionalDragInfo}
            onFilterChanged={onFilterChanged}
            filterOperators={filterOperators}
            filterOrder={filterOrder}
            defaultMessage={
              isSearchModePage
                ? isDeepSearchPerformed
                  ? T.translate('case.searchNoMatch')
                  : T.translate('case.searchModePageDefaultMsg')
                : isDocFinderPage || isPresentModeWithBackEnd
                  ? isDeepSearchPerformed
                    ? T.translate('case.searchNoMatch')
                    : T.translate('case.docFinderPageDefaultMsg')
                  : ''
            }
            showHeaderWhenEmpty
            emptyState={combinedEmptyState}
            emptyStateAlign={suppressRows && uploadEmptyState ? 'top' : 'center'}
            gridList={gridList}
            setGridList={setGridList}
            mappedRowsWithErrors={mappedRowsWithErrors}
          />
          <Modal
            show={!!showModal}
            handleSave={() => {
              setShowModal(false);
              showModal?.fn();
            }}
            handleClose={() => setShowModal(undefined)}
            title={T.translate('generic.areYouSure')}
            saveTitle={T.translate('generic.yes')}
          >
            {T.translate('case.areYouSureSort')}
          </Modal>
        </>
      );
    },
  ),
);

export default TableCase;
